import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UIMatch, useMatches } from 'react-router';
import { RouteHandle } from 'types/ReactRouter';

const ROUTE_PARAMS_MAPPER: Record<string, string> = { '/alerts': 'type' };

const usePageTitle = () => {
    const { t } = useTranslation('navigation', { keyPrefix: 'browser_tab' });
    const matches = useMatches() as UIMatch<unknown, RouteHandle>[];

    useEffect(() => {
        const defaultTitle = t('default');
        const routeWithTitle = matches
            .filter((match) => match.handle?.title)
            .at(-1);

        if (!routeWithTitle?.handle.title) {
            document.title = defaultTitle;
            return;
        }

        const routeParam =
            routeWithTitle?.params[
                ROUTE_PARAMS_MAPPER[routeWithTitle.pathname]
            ];
        const pageTitle = routeParam
            ? t(`${routeWithTitle.handle.title}.${routeParam}`)
            : t(routeWithTitle.handle.title);

        document.title = `${pageTitle} | ${defaultTitle}`;
    }, [matches, t]);
};

export default usePageTitle;
